var _rect, _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDeleteRoundedIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 70,
    height: 70,
    rx: 35,
    fill: "#FFE5E5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.125 25.75H24.2083H48.875",
    stroke: "#F70000",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M45.7917 25.7502V47.3335C45.7917 48.1512 45.4668 48.9355 44.8886 49.5137C44.3103 50.092 43.5261 50.4168 42.7083 50.4168H27.2917C26.4739 50.4168 25.6897 50.092 25.1114 49.5137C24.5332 48.9355 24.2083 48.1512 24.2083 47.3335V25.7502M28.8333 25.7502V22.6668C28.8333 21.8491 29.1582 21.0648 29.7364 20.4866C30.3147 19.9083 31.0989 19.5835 31.9167 19.5835H38.0833C38.9011 19.5835 39.6853 19.9083 40.2636 20.4866C40.8418 21.0648 41.1667 21.8491 41.1667 22.6668V25.7502",
    stroke: "#F70000",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31.9167 33.4585V42.7085",
    stroke: "#F70000",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M38.0833 33.4585V42.7085",
    stroke: "#F70000",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteRoundedIcon);
export default __webpack_public_path__ + "static/media/DeleteRoundedIcon.d30d4290380e1336cfb9f98b4948fa0a.svg";
export { ForwardRef as ReactComponent };